import { lazy } from 'react';

import { RouterSuspense } from '@/lib';

export const OrdersPageAsync = RouterSuspense(
  lazy(() => import('./index.tsx')),
);
